import React from "react";
import {Button} from "react-bootstrap";
import Loading from "../Loading/Loading";

export const CustomCardFooter = ({onClick, hasMoreItems}) => {
  return (
    <div style={styles.footer}>
      {hasMoreItems ?
        <div>
          <Loading/>
        </div> :
        <Button title="Carregar Mais" onClick={onClick} style={styles.button}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill='#3c8dbc'>
            <path
              d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/>
          </svg>
        </Button>
      }

    </div>
  )
}
const styles = {
  footer: {
    bottom: 20,
    right: 0,
    paddingTop: 50,
    left: 0,
    position: "absolute",
    display: "flex",
    justifyContent: "center",
  },
  button: {
    position: "block",
    border: "0",
    backgroundColor: "transparent",
    width: "5.5rem"
  },
}



// WEBPACK FOOTER //
// ./src/component/List/CustomCardFooter.js